import { Component, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import { DeparaItens } from 'src/app/interfaces/depara-itens';
import { Item } from 'src/app/interfaces/item';
import { ApiService } from 'src/app/services/api.service';
import { ApiLoginService } from 'src/app/services/login/api-login.service';
import { TipoIntegracao } from 'src/app/interfaces/tipo-integracao';
import { Route, Router } from '@angular/router';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {
  option:string = ''
  routePesqPend:string = 'pendencias-nfe';
  modalSize:string = ''
  modalUpdate:boolean = false;
  ModalTitle:string = '';
  ModalBody:string = '';
  ModalButtons:Array<any> = [];
  ModalTitleToolbar:string = '';
  ModalBodyToolbar:string = '';
  ModalButtonsToolbar:Array<any> = [];
  colorMessage:string = "alert alert-warning";
  titleMessage:string = "Nenhum registro encontrado";
  Parametro:string  = '';
  checkboxRequired:boolean = true;
  checkBtn:any = {normal:false, tms:false}
  ParametroPopups:string = ''
  tipoPopup:string = '';
  intgTipo:string = '';
  visualizaDanfe:string = '';
  usuarioLogado: any = {};
  listaPopup:Array<any> = [];
  excluirItem:any = '';
  filtroPopup:any =   {
    cod       : '',
    descricao : ''
  };
  @Input() usuarioAutenticadoP: boolean = false;
  DeparaItem:DeparaItens = {} as DeparaItens;
  DeparalistaItensFiltro:Array<DeparaItens> = [];
  DeparalistaItens:Array<DeparaItens> = [];
  listaItens:Array<Item> = [
    {
      id        : 1,
      cod       : 'AC001',
      descricao : 'Chapa de Aço Carbono'
    },
    {
      id        : 2,
      cod       : 'AF002',
      descricao : 'Barra de Ferro Fundido'
    },
    {
      id        : 3,
      cod       : 'AA003',
      descricao : 'Placa de Aço Galvanizado'
    },
    {
      id        : 4,
      cod       : 'BL004',
      descricao : 'Barra de Latão'
    },
    {
      id        : 5,
      cod       : 'AF005',
      descricao : 'Fio de Aço Inoxidável'
    },
    {
      id        : 6,
      cod       : 'BB006',
      descricao : 'Barra de Bronze'
    },
    {
      id        : 7,
      cod       : 'AC007',
      descricao : 'Chapa de Aço Inoxidável'
    },
    {
      id        : 8,
      cod       : 'PF008',
      descricao : 'Perfil de Ferro Nodular'
    }
  ];
  fornecedores:Array<any> = [
    {
      cod:'049323579000201',
      descricao:'WACKER QUIMICA DO BRASIL LTDA'
    },
    {
      cod:'002624190000496',
      descricao:'BIOGENESIS BAGO SAUDE ANIMAL LTDA1'
    },
    {
      cod:'006147118000123',
      descricao:'INNOVARE BIOTECNOLOGIA E SAUDE ANIM'
    }
  ]
  unidadesDeMedida:Array<any> = [
    { cod: 'cm', descricao: 'Centímetro' },
    { cod: 'mm', descricao: 'Milímetro' },
    { cod: 'km', descricao: 'Quilômetro' },
    { cod: 'ft', descricao: 'Pé' },
    { cod: 'in', descricao: 'Polegada' },
    { cod: 'yd', descricao: 'Jarda' },
    { cod: 'm²', descricao: 'Metro quadrado' },
    { cod: 'km²', descricao: 'Quilômetro quadrado' },
    { cod: 'ha', descricao: 'Hectare' },
    { cod: 'm³', descricao: 'Metro cúbico' },
    { cod: 'L', descricao: 'Litro' },
    { cod: 'ml', descricao: 'Mililitro' },
    { cod: 'mL', descricao: 'Microlitro' },
    { cod: 'g', descricao: 'Grama' },
    { cod: 'mg', descricao: 'Miligrama' },
    { cod: 'kg', descricao: 'Quilograma' },
    { cod: 'ton', descricao: 'Tonelada' },
    { cod: 'ct', descricao: 'Quilate' },
    { cod: 'doz', descricao: 'Dúzia' },
    { cod: 'dz', descricao: 'Dezena' },
    { cod: 'un', descricao: 'Unidade' },
  ];

  chk:any = {
    numero_nf           : true,
    destinatario_nfe    : false,
    numero_cte          : false,
    destinatario_cte    : false,
    emitente_nfe        : false,
    transportadora_nfe  : false,
    emitente_cte        : false,
    transportadora_cte  : false
  }

  tipoPesquisa:string = '1';

  pesquisarPendencia:any = {
    search_pendencia  : '',
    chk               : ''
  }
  XMLfile:any = {} 

  revalidaPendecias:any = {
    data_de   :'',
    data_ate :'',
    chk       :{
      tipo_pendencia_nf   : true,
      tipo_pendencia_ct   : false,
      tipo_pendencia_tms  : false,
      tipo_pendencia_tipo : false
    }
  }
  alertMsg:boolean = true;

  baixaXML:any = {
    AcessKey:'',
    chk:{
      tms         : false,
      devolucao   : false,
      provisoria  : false
    }
  }

  loteDownload:any = {
    file:{},
    nome:'',
    tipo:''
  }

  listaTiposIntegracao2:Array<TipoIntegracao> = [];

  integraTipo:any = {
    file:{},
    tipo:''
  }
  importFile:any = '';

  constructor(
    private API: ApiService,
    private apiLogin: ApiLoginService,
    private router: Router,
    private elementRef: ElementRef
  ) { }

// FUNÇÕES GERAIS //

@HostListener('document:click', ['$event.target'])
onDocumentClick(target: EventTarget | null): void {
  if(this.router.url != "/login"){
    const isInside = this.elementRef.nativeElement.querySelector('#card-toolbar').contains(target);
    if (!isInside) {
      this.closeToolbar();
    }
  }
}

@HostListener('document:keydown.enter')
handlerenter(){
  
  const _self = this;
  var modalOption:any = document.getElementById('modalOptions')
  var modalAlert:any = document.getElementById('modalAlert')
  var modalFilePicker:any = document.getElementById('file_p_download_xml')

  if(Array.from(modalOption.classList).some((value:any) => value?.includes('show'))){
    switch (_self.option) {
      case 'pesq_pend':
        _self.pesqPendecias() 
        break;
      case 'view_danfe':
        _self.visualizarDanfe()
        break;
      case 'rvl_pend':
        _self.revalidarPendencias()
        break;
      case 'download_xml':
        _self.baixarXML()
        break;
      case 'send_lot':
        _self.enviaLoteDownload()
        break;
      case 'import_ne':
        _self.importNotaEntrada()
        break;
      case 'integr_tipo':
        _self.enviaIntegracaoTipo()
        break;
    }
  }

  if(Array.from(modalAlert.classList).some((value:any) => value?.includes('show'))){
    document.getElementById('first_button_modal_alert')?.click()
  }

  if(Array.from(modalFilePicker.classList).some((value:any) => value?.includes('show'))){
    document.getElementById('enviaDownloadXML_button')?.click()
  }
}

  ngOnInit(): void {
    const _self = this;
    _self.getUsuarioStorage();
  }

  getUsuarioStorage() {
    const _self = this;
    _self.apiLogin.getUsuarioStorage()
      .then(usuarioStorage => {
        if (usuarioStorage != undefined) {
          _self.usuarioLogado = usuarioStorage;
        }
      })
      .catch(erro => {
        console.warn('app.component.ts - erro ao buscar usuario no datastorage: ', erro)
      })
    }
  
  rotate(){
    document.getElementById('showMore_button')?.classList.toggle('rotacionando')
  }
  
  modalOptions(opt:string, modalSize:string){
    const _self = this;
    _self.option = opt

    switch(opt){
      case'maint_dp-itens':
        // _self.getListaItens();
      break;
      case'integr_tipo':
        _self.getListaIntegracao2()
      break;
      case'rvl_pend':
        var dataAtual:any = new Date();
        dataAtual = dataAtual.toISOString().split('T')[0]

        _self.revalidaPendecias.data_de = dataAtual
        _self.revalidaPendecias.data_ate = dataAtual
        
      break;
      case'pesq_pend':
        _self.routePesqPend = 'pendencias-nfe';
        _self.tipoPesquisa = '1'
      break;
    }

    _self.modalSize = modalSize
    _self.closeToolbar()
  }


// PESQUISAR PENDENCIAS //
  marcarTipoPesqPend(tipo:string){
    const _self = this;
    _self.chk = {
      numero_nf           : false,
      destinatario_nfe    : false,
      numero_cte          : false,
      destinatario_cte    : false,
      emitente_nfe        : false,
      transportadora_nfe  : false,
      emitente_cte        : false,
      transportadora_cte  : false
    }
    _self.pesquisarPendencia.chk = tipo

    switch(tipo){
      case'numero_nf':
      _self.chk.numero_nf = true;
      _self.tipoPesquisa = '1';
      _self.routePesqPend = 'pendencias-nfe';
      break;
      case'destinatario_nfe':
      _self.chk.destinatario_nfe = true;
      _self.tipoPesquisa = '3';
      _self.routePesqPend = 'pendencias-nfe';
      break;
      case'numero_cte':
      _self.chk.numero_cte = true;
      _self.tipoPesquisa = '1';
      _self.routePesqPend = 'pendencias-cte';
      break;
      case'destinatario_cte':
      _self.chk.destinatario_cte = true;
      _self.tipoPesquisa = '3';
      _self.routePesqPend = 'pendencias-cte';
      break;
      case'emitente_nfe':
      _self.chk.emitente_nfe = true;
      _self.tipoPesquisa = '2';
      _self.routePesqPend = 'pendencias-nfe';
      break;
      case'transportadora_nfe':
      _self.chk.transportadora_nfe = true;
      _self.tipoPesquisa = '4';
      _self.routePesqPend = 'pendencias-nfe';
      break;
      case'emitente_cte':
      _self.chk.emitente_cte = true;
      _self.tipoPesquisa = '2';
      _self.routePesqPend = 'pendencias-cte';
      break;
      case'transportadora_cte':
      _self.chk.transportadora_cte = true;
      _self.tipoPesquisa = '4';
      _self.routePesqPend = 'pendencias-cte';
      break;
    }

    // console.log(_self.chk)
  }

  pesqPendecias(){
    const _self = this;
    
    var param:any = {
      state: {
        tipo: _self.tipoPesquisa,
        pesquisa: _self.pesquisarPendencia.search_pendencia
      }
    }
    _self.router.navigate(['/'+_self.routePesqPend],param)
    
    document.getElementById('pesq_pend_close_button')?.click()
  }

// VISUALIZAR DANFE //
  visualizarDanfe(){
    const _self = this;

    var obj = {
      action  : "visualizarDanfeArq",
      dados : _self.XMLfile
    }
    _self.API.getFromApi('Popup', 'toolbar', obj, (Retorno:any) => {
      if(Retorno.mostraRetorno){
        console.log("RETORNO API =", Retorno);
      }
      if(Retorno.status){
        window.open(Retorno.arquivo)
      }
    },true,"")
  }

  capturaArquivo(input:any){
    const _self = this;
    var file:any = input.target;
    _self.XMLfile = file.files[0]
  }

// REVALIDAR PENDENCIAS //
  selecionaTipoRvldPend(selecionado:string){ 
    const _self = this;
    var div_checks:any = document.getElementById('pendencias_check_rlvd')?.childNodes
    var checkboxs
    for(let i = 0; i < div_checks.length; i++){
      checkboxs = div_checks[i]?.childNodes
      for(let j = 0; j < checkboxs.length; j++){
        if(checkboxs[j].id != selecionado){
          if(checkboxs[j].checked){
            document.getElementById(checkboxs[j].id)?.click()
          }
        }
      }
    }

  }

  revalidarPendencias(){
    const _self = this;
    if(_self.revalidaPendecias.data_de == '' || _self.revalidaPendecias.data_ate == ''){
      _self.alertMsg = false
    }else{
      _self.alertMsg = true
      
      var tipo = '';
      if(_self.revalidaPendecias.chk.tipo_pendencia_nf){
          tipo = 'NF'  
      }
      if(_self.revalidaPendecias.chk.tipo_pendencia_ct){
          tipo = 'CT'
      }
      if(_self.revalidaPendecias.chk.tipo_pendencia_tms){
          tipo = 'TMS'
      }
      if(_self.revalidaPendecias.chk.tipo_pendencia_tipo){
          tipo = 'NFTIPO'
      }

      var obj = {
        action  : "revalidarPendencias",
        dados : {
          data_de  : _self.revalidaPendecias.data_de,
          data_ate : _self.revalidaPendecias.data_ate,
          tipo     : tipo 
        }
      }
      
      _self.API.getFromApi('Popup', 'toolbar', obj, (Retorno:any) => {
        if(Retorno.mostraRetorno){
          console.log("RETORNO API =", Retorno);
        }
        
        setTimeout(() => {
          _self.ModalTitleToolbar = 'Info';
          _self.ModalBodyToolbar =  Retorno.message;
          _self.ModalButtonsToolbar = [
            {
              action: '',
              type: 'confirm',
              text: 'Fechar',
              class: 'btn-primary'
            },
          ];
          document.getElementById('show-modalToolbar')?.click();
          setTimeout(() => {
            document.getElementById('close-modalToolbar')?.click();
          }, 5500);
        }, 500);
      },true,"")
    }

  }

// BAIXAR XML //
  baixarXML(){
    
    const _self = this;
    if(_self.baixaXML.AcessKey == ''){
      _self.alertMsg = false
    }else{
      _self.alertMsg = true
      
      _self.API.getFromApi('BaixaXML', 'Baixar',_self.baixaXML, (Retorno:any) => {
        if(Retorno.mostraRetorno){
          console.log("RETORNO API =", Retorno);
        }
      },true,"");
    }
  } 

  selecionaTipoBaixaXML(selecionado:string){ 
  const _self = this;
  var div_checks:any = document.getElementById('chk_dowloadXML')?.childNodes
  var checkboxs
  for(let i = 0; i < div_checks.length; i++){
    checkboxs = div_checks[i]?.childNodes
    for(let j = 0; j < checkboxs.length; j++){
      if(checkboxs[j].id != selecionado){
        if(checkboxs[j].checked){
          document.getElementById(checkboxs[j].id)?.click()
        }
      }
    }
  }

  }

  enviaDownloadXML(){
  const _self = this;
  var file:any = document.getElementById('formFile');
  if(file.files[0] != undefined){
    _self.alertMsg = true;
    _self.API.getFromApi('BaixaXML', 'Enviar', {file: file.files[0]}, (Retorno:any) => {
      if(Retorno.mostraRetorno){
        console.log("RETORNO API =", Retorno);
      }
      document.getElementById('file_p_download_xml_close')?.click()
    },true,"")
    //TST//
      document.getElementById('file_p_download_xml_close')?.click()
    //TST//
  }else{
    _self.alertMsg = false;
  }
  }

// ENVIO DE LOTE DOWNLOAD//
  enviaLoteDownload(){
    const _self = this;
    var file:any = document.getElementById('formFile_send_lot')
    _self.loteDownload.file = file.files[0]

    _self.API.getFromApi('EnviaLote','Download',_self.loteDownload,(Retorno:any) => {
      if(Retorno.mostraRetorno){
        console.log("RETORNO API =", Retorno);
      }
      document.getElementById('send_lot_close')?.click()
    },true,"");
    
    //TST//
      document.getElementById('send_lot_close')?.click()
    //TST//
  }

// IMPORTA NOTA DE ENTRADA //
  importNotaEntrada(){

    const _self = this;
    var obj = {
      action  : "importaNotaEntrada",
      dados : _self.XMLfile
    }

    if(!(_self.XMLfile.name.endsWith(".zip"))){ 
      setTimeout(() => {
        _self.ModalTitleToolbar = 'Info';
        _self.ModalBodyToolbar =  'Extensao inválida. O arquivo deve estar compactado em .zip'
        document.getElementById('show-modalToolbar')?.click();
        setTimeout(() => {
          document.getElementById('close-modalToolbar')?.click();
          document.getElementById('import_ne_btn_toolbar')?.click();
        }, 10500);
      }, 500);
    }else{
      _self.API.getFromApi('Popup', 'toolbar',obj,(Retorno:any) => {
        if(Retorno.mostraRetorno){
          console.log("RETORNO API =", Retorno);
        }
        setTimeout(() => {
          _self.ModalTitleToolbar = 'Info';
          _self.ModalBodyToolbar =  Retorno.message
          document.getElementById('show-modalToolbar')?.click();
          setTimeout(() => {
            document.getElementById('close-modalToolbar')?.click();
          }, 10500);
        }, 500);
      },true,"");
    }
    _self.importFile = '';
  }

// INTEGRAÇÃO POR TIPO //

  getListaIntegracao2() {
    
    const _self = this;
    _self.API.getFromApi('TiposIntegr', 'select', {}, (Retorno: any) => {
      if(Retorno.mostraRetorno){
        console.log("RETORNO API =", Retorno);
      }
      _self.listaTiposIntegracao2 = JSON.parse(JSON.stringify(Retorno.tipointegracao));
    }, true, "");

  }

  enviaIntegracaoTipo(){
    const _self = this;
    
    var obj = {
      action : "integracaoPorTipo",
      dados  : {
        file : _self.XMLfile,
        tipo : _self.integraTipo.tipo
      }
    }
    if(!(_self.XMLfile.name.endsWith(".zip"))){
      setTimeout(() => {
        _self.ModalTitleToolbar = 'Info';
        _self.ModalBodyToolbar =  'Extensao inválida. O arquivo deve estar compactado em .zip'
        document.getElementById('show-modalToolbar')?.click();
        setTimeout(() => {
          document.getElementById('close-modalToolbar')?.click();
          document.getElementById('integr_tipo_btn_toolbar')?.click();
        }, 2500);
      }, 500);
    }else{
      _self.API.getFromApi('Popup', 'toolbar', obj, (Retorno:any) => {
        if(Retorno.mostraRetorno){
          console.log("RETORNO API =", Retorno);
        }
        setTimeout(() => {
          _self.ModalTitleToolbar = 'Info';
          _self.ModalBodyToolbar =  Retorno.message
          document.getElementById('show-modalToolbar')?.click();
          setTimeout(() => {
            document.getElementById('close-modalToolbar')?.click();
          }, 2500);
        }, 500);
      }, true, "");

    }


  }

// MANUTENÇÃO DE-PARA ITENS //

  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(event: Event) {
    const _self = this;
    setTimeout(() => {
      _self.limpaForm()
    }, 150);
  }

  limpaForm(): void{
    const _self = this;
    _self.intgTipo = ''
    _self.visualizaDanfe = ''
    _self.DeparaItem = {} as DeparaItens;
    _self.ParametroPopups= '';
    _self.checkboxRequired = true;
    _self.alertMsg = true
    _self.checkBtn = {normal:false, ncm:false}
    _self.listaPopup = []
    _self.tipoPopup = ''
    _self.XMLfile = '';
    _self.pesquisarPendencia = {
      search_pendencia  : '',
      chk               : ''
    }
    _self.chk = {
      numero_nf           : true,
      destinatario_nfe    : false,
      numero_cte          : false,
      destinatario_cte    : false,
      emitente_nfe        : false,
      transportadora_nfe  : false,
      emitente_cte        : false,
      transportadora_cte  : false
    }

    _self.loteDownload = {
      file:{},
      nome:'',
      tipo:''
    }

    _self.integraTipo = {
      file:{},
      tipo:''
    }
    
    _self.revalidaPendecias = {
      data_de   :'',
      data_ate :'',
      chk       :{
        tipo_pendencia_nf   : true,
        tipo_pendencia_ct   : false,
        tipo_pendencia_tms  : false,
        tipo_pendencia_tipo : false
      }
    }
  }

  closeToolbar(){
    var element:any = document.getElementById('toolbarCollapse')
    if(element.classList.contains('show')){
      setTimeout(() => {
        document.getElementById('acordButton')?.click()
      }, 150);
    }

  }
}
